import {useEffect, useState } from 'react';
import $ from 'jquery';
import { properties } from '../../properties';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';

function TokenAuth({ apiUrl }) {
    const [tokenAuth, setTokenAuth] = useState({
        operation: properties.OPERATIONS.tokenauth,
        timestamp:"",
        transactionid: transidgenerator(),
        vendorid: properties.VENDOR_ID,
        method:properties.HTTP_METHOD,
        password: properties.PASSWORD,
        description: properties.DESCRIPTION,
        value: properties.VALUE,
        currency: properties.CURRENCY,
        region: properties.SEL_REGION,
        token: properties.TOKEN,
        address: properties.ADDRESS,
        postCode: properties.POST_CODE,
        countryCode: properties.COUNTRY_CODE,
        allowAvsFail: properties.ALLOW_AVS_FAIL,
        security:""
    });
    
    const [isDpaFlag, setIsDpaFlag] = useState("false");

    var region =[];

    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    var canSubmit = true;

    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }
    
    function changeTransactionId(e) {
        isNotNullCheck(e.target.value,"WPG_transID");
        setTokenAuth({ ...tokenAuth, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value,"WPG_vendorID");
        setTokenAuth({ ...tokenAuth, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value,"vendorPwd");
        setTokenAuth({ ...tokenAuth, password: e.target.value });
    }

    function changeDesc(e) {
        setTokenAuth({ ...tokenAuth, description: e.target.value });
    }

    function changeValue(e) {
        isNotNullCheck(e.target.value,"WPG_value");
        setTokenAuth({ ...tokenAuth, value: e.target.value });
    }

    function changeCurrency(e) {
        isNotNullCheck(e.target.value,"WPG_currency");
        setTokenAuth({ ...tokenAuth, currency: e.target.value });
    }

    function changeToken(e) {
        isNotNullCheck(e.target.value,"WPG_token");
        setTokenAuth({ ...tokenAuth, token: e.target.value });
    }

    function changeAddr(e) {
        setTokenAuth({ ...tokenAuth, address: e.target.value });
    }

    function changePostCode(e) {
        setTokenAuth({ ...tokenAuth, postCode: e.target.value });
    }

    function changeCountryCode(e) {
        setTokenAuth({ ...tokenAuth, countryCode: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value,"WPG_region");
        setTokenAuth({ ...tokenAuth, region: e.target.value });
    }

    function changeAllowAvsFail(e) {
        setTokenAuth({ ...tokenAuth, allowAvsFail: e.target.value });
    }

    function changeDpaFlag(e) {
        setIsDpaFlag(e.target.value);
    }

    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);

    function submitTokenAuthForm(e) {
        e.preventDefault();
        isNotNullCheck(tokenAuth.password,"vendorPwd");
        isNotNullCheck(tokenAuth.vendorid,"WPG_vendorID");
        isNotNullCheck(tokenAuth.transactionid,"WPG_transID");
        isNotNullCheck(tokenAuth.value,"WPG_value");
        isNotNullCheck(tokenAuth.token,"WPG_token");
        isNotNullCheck(tokenAuth.region,"WPG_region");
        isNotNullCheck(tokenAuth.currency,"WPG_currency");
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            if(tokenAuth.region === "NoR"){
                setTokenAuth({...tokenAuth, region:""});
            }
            $("#pwd").remove();
            var md5 = require('md5');
            var time = Math.floor(Date.now() / 1000);
            $("#tokenauth_timestamp").val(time);
            var digest = md5(time + tokenAuth.vendorid +
                tokenAuth.transactionid + tokenAuth.method + tokenAuth.description +
                tokenAuth.value + tokenAuth.currency + tokenAuth.region +
                tokenAuth.token + tokenAuth.address + tokenAuth.postCode +
                tokenAuth.countryCode + tokenAuth.allowAvsFail + tokenAuth.password);
            $("#tokenauth_security").val(digest);
            $("#tokenauthForm").attr('action', apiUrl).submit();
        }
    }

    var tokenAuthTemplate = (
        <div className="operation-form">
            <h2>Token Authorise</h2>
            <form className="form-horizontal" method='post' id="tokenauthForm" onSubmit={submitTokenAuthForm}>
                <input type="hidden" name="WPG_timestamp" id="tokenauth_timestamp" value="" />
                <input type="hidden" name="WPG_security" id="tokenauth_security" value="" />
                <input type="hidden" name="WPG_operation" value={tokenAuth.operation} />
                <input type="hidden" name="WPG_method" value={tokenAuth.method}/>
                <div className="form-group">
                    <div className="control-label">
                        Dpa Flag
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_dpaFlag" value={isDpaFlag} onChange={changeDpaFlag}>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={tokenAuth.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={tokenAuth.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group" id="pwd">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={tokenAuth.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_description" value={tokenAuth.description} onChange={changeDesc} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Value<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_value" value={tokenAuth.value} onChange={changeValue} />
                        <div className="error-msg" name="WPG_value">Value is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Currency Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_currency" value={tokenAuth.currency} onChange={changeCurrency} />
                        <div className="error-msg" name="WPG_currency">ISO Currency Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={tokenAuth.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Token<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_token" value={tokenAuth.token} onChange={changeToken} />
                        <div className="error-msg" name="WPG_token">Token is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Address
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_address" value={tokenAuth.address} onChange={changeAddr} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Postal/Zip Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_postcode" value={tokenAuth.postCode} onChange={changePostCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Country Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_countryCode" value={tokenAuth.countryCode} onChange={changeCountryCode } />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Allow AVS Fail
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_allowAVSFail" value={tokenAuth.allowAvsFail} onChange={changeAllowAvsFail}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" className="btn btn-primary">Perform</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>

    );

     
    return tokenAuthTemplate;

}

export default TokenAuth;